/* eslint-disable vue/multi-word-component-names */
// import 'babel-polyfill'
import '@/utils/rem';
import Vue from 'vue';
import './utils/element';
import App from './App.vue';
import store from './store';
import '@/styles/index.scss';
import router from './router';
import imgError from '@/utils/imgError';
import overflow from '@/utils/overflow';
import empty from '@/views/components/empty.vue';
import pagination from '@/components/pagination';


Vue.component('empty', empty);
Vue.config.productionTip = false;
Vue.directive('imgError', imgError);
Vue.directive('overflow', overflow);

let count = 0;
function number(value) {
    return !isNaN(+value) && Number.isFinite(+value);
};

const HEIGHT = 'height';
const VERTICAL = 'vertical';
const HORIZONTAL = 'horizontal';
function unification(binding) {
    const value = binding.value;
    const data = { mode: HEIGHT, duration: 1500 };
    switch(!0) {
        case typeof value === 'object': {
            if (number(value.default) || number(value.size)) {
                data.value = +value.default || +value.size;
            };

            if (number(value.duration)) {
                data.duration = value.duration;
            };
            
            if ([VERTICAL, HORIZONTAL].includes(value.mode)) {
                data.mode = value.mode === VERTICAL ? HEIGHT : 'width';
            };

            break;
        }

        case number(value): {
            data.value = +value;
            break;
        }

        case number(binding.arg): {
            data.value = +binding.arg;
            break;
        }
    };

    data.mode = data.mode.slice(0, 1).toLocaleUpperCase() + data.mode.slice(1);
    return data;
};

function autoAdjustFontSize(oldEl, defaultSize, mode, step = 1) {
    const attribute = 'data-count';
    const lastTextAttribute = 'data-last-text';
    const el = oldEl;
    if (!el) {
        return;
    };

    if (el.textContent == '0') {
        el.removeAttribute(attribute);
        el.removeAttribute(lastTextAttribute);
        el.style.fontSize = defaultSize + 'px';
        return;
    };

    const attributeValue = +(el.getAttribute(attribute) || '0') + 1;
    const lastText = el.getAttribute(lastTextAttribute);
    el.setAttribute(attribute, attributeValue.toString());
    if (lastText !== el.textContent) {
        el.style.fontSize = defaultSize + 'px';
        el.setAttribute(lastTextAttribute, el.textContent);
    };

    function updated() {
        const size = el.style.fontSize ? +el.style.fontSize.replace(/px/, '') : defaultSize;
        el.style.fontSize = size - step + 'px';
    };
    
    // @ts-ignore
    if (el[`scroll${mode}`] > el[`client${mode}`]) {
        updated()
        autoAdjustFontSize(oldEl, defaultSize, mode);
    }
    else if (attributeValue > 3) {
        // step = 2;
        // updated();
    };
};

function start(el, mode, value) {
    if (!value) {
        throw new Error('默认值是必传项');
    };

    autoAdjustFontSize(el, value, mode);
};

Vue.directive('autoAdjustFontSize', {
    update(el, binding) {
        const { mode, value, duration } = unification(binding);
        duration ? setTimeout(() => {
            start(el, mode, value);
        }, 
        duration) : start(el, mode, value);
    },
    inserted(el, binding) {
        const { mode, value, duration } = unification(binding);
        count++;
        el.id = 'auto-djust-font-size_' + count;
        duration ? setTimeout(() => {
            start(el, mode, value);
        }, 
        duration) : start(el, mode, value);
    }
});

Vue.component('pagination', pagination);


/** 是否 ipad */
Vue.prototype.$ipad = navigator.maxTouchPoints >= 1;

/** 取消 ipad 鼠标手势 */
Vue.prototype.$cancelIpadCursor = function() {
    if (this.$ipad) {
        document.body.classList.add('no-cursor');
    };
};

/** 单词条容器样式 */
Vue.prototype.$wordBarViewStyle = function() {
    return { paddingRight: this.$ipad ? '10rem' : '68.7rem' };
};


new Vue({
    router,
    store,
    render: (h) => h(App)

}).$mount('#app');
